<template>
    <div>
        <h3 class="mb-3" :class="this.totalData.avgBotMsg==0 && this.totalData.avgUserMsg==0? 'text-center': ''">Average total number of messages per session</h3>
        <div class="no-data-placeholder text-center" v-if="this.totalData.avgBotMsg==0 && this.totalData.avgUserMsg==0">
            <v-progress-circular
                    :rotate="-90"
                    :size="220"
                    :value="100 "
                    :width="30"
                    color="grey"
            >
                <span>Messages / session</span>
                <span>0</span>
            </v-progress-circular>
        </div>
        <apex-chart type="donut" width='90%' :options="chartOptions" :series="series" ></apex-chart>
    </div>
</template>

<script>
    import apexChart from 'vue-apexcharts'
    export default {
        name: "total-messages",
        components: {
            apexChart
        },
        props: {
            totalData: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        data() {
            return {
                series: [],
                chartOptions: {
                    plotOptions: {
                        pie: {
                            donut: {
                                labels: {
                                    show: true,
                                    style: {
                                      fontSize: '13px'
                                    },
                                    value: {
                                        offsetY: -1,
                                        show: true,
                                        // formatter: function (val) {
                                        //     console.log(val, ' formatter')
                                        //     return val
                                        // }
                                    },
                                    total: {
                                        show: true,
                                        label: 'Messages / session',
                                        color: '#000',
                                        fontSize: '13px',
                                        formatter: function (w) {
                                            let total = w.globals.seriesTotals.reduce((a, b) => {
                                                return a + b;
                                            }, 0);
                                            return total.toFixed(2);
                                        }
                                    }
                                },
                            }
                        }
                    },
                    labels: [],
                    chart: {
                        type: 'donut'
                    }
                }
            }
        },
        mounted() {
            if (this.totalData.avgBotMsg==0 && this.totalData.avgUserMsg==0){
                this.series = [];
                this.chartOptions= {
                    labels: []
                };
            }else{
                this.series = [this.totalData.avgBotMsg, this.totalData.avgUserMsg];
                this.chartOptions= {
                    labels: ['Bot','User']
                };
            }

        },
        watch: {
            totalData() {
                if (this.totalData.avgBotMsg==0 && this.totalData.avgUserMsg==0){
                    this.series = [];
                    this.chartOptions= {
                        labels: []
                    };
                }else{
                    this.series = [this.totalData.avgBotMsg, this.totalData.avgUserMsg];
                    this.chartOptions= {
                        labels: ['Bot','User']
                    };
                }
            }
        }
    }
</script>

<style scoped>
    .no-data-placeholder{
        margin-top: 30px;
    }
@media (max-width:1400px) {
    .apexcharts-datalabel-label {
        font-size: 11px !important;
    }
}
</style>
<style lang="scss">
.no-data-placeholder{
    .v-progress-circular__info{
        width: 100%;
        span{
            display: block;
            font-size: 16px;
            color: #000;
        }
    }
}
</style>